module.exports = __webpack_public_path__ + "static/media/search.2a698384.svg";